var _rect, _g, _rect2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTeamPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1911_248015",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 16,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6.40002,
    width: 16,
    height: 17.6,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1911_248015)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.2002,
    y: 19.2001,
    width: 12.8,
    height: 12.8,
    rx: 4.8,
    stroke: "black",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.8165,
    cy: 12.6969,
    r: 3.09677,
    stroke: "black",
    strokeWidth: 1.4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1911_248015",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 6,
    width: 16,
    height: 19
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17.6,
    transform: "matrix(-1 0 0 1 32 6.40015)",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1911_248015)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8,
    height: 12.8,
    rx: 4.8,
    transform: "matrix(-1 0 0 1 28.7998 19.2002)",
    stroke: "black",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.09677,
    transform: "matrix(-1 0 0 1 22.5033 12.697)",
    stroke: "black",
    strokeWidth: 1.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeamPopup);
export default __webpack_public_path__ + "static/media/icon_team_popup.3caf90b794ef717e495bb5dbf38b35fa.svg";
export { ForwardRef as ReactComponent };